/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BaseKey, GetOneResponse, useNotification } from "@refinedev/core";
import { QueryObserverResult } from "@tanstack/react-query";
import {
  Badge,
  Button,
  Col,
  Form,
  FormProps,
  Modal,
  ModalProps,
  Row,
  Typography
} from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";

import {
  useChangeStatusExchange,
  useGetDetailExchange
} from "../../api/wallet";
import TextContent from "../../components/modal/admin/text-content";
import PaymentStatus from "../../types/paymentStatus.type";
import { useIsAdminRole } from "../../utils/hooks/useIdentityAdmin.hook";
import {
  paymentStatusColors,
  paymentStatusNames,
} from "../../utils/paymentStatus.utils";
import { PaymentRequestsEditForm } from "../components/interface";

interface IProps {
  formProps: FormProps;
  modalProps: ModalProps;
  queryResult?: QueryObserverResult<GetOneResponse<PaymentRequestsEditForm>>;
  id?: BaseKey;
  resetEditingId: () => void;
  formIsLoading: boolean;
  close: () => void;
  refetchExchange: any;
}

export const ExchangeEdit = ({
  modalProps,
  formProps,
  queryResult,
  id,
  resetEditingId,
  close,
  refetchExchange,
}: IProps) => {
  const { open: openNotification } = useNotification();
  const isAdminRole = useIsAdminRole();
  const [statusChange, setStatusChange] = useState<any>();
  const [invalidFund, setInvalidFund] = useState<any>("");

  const { data } = useGetDetailExchange(id || 0);

  const { mutate, isLoading } = useChangeStatusExchange({
    onSuccess: (response: { data: { message: string } }) => {
      if (openNotification) {
        openNotification({
          key: "success_transaction_confirm",
          message: response?.data?.message || "Change status successfully!",
          type: "success",
        });
      }
      refetchExchange();
      setStatusChange(null);
      close();
      setInvalidFund("");
    },
    onError: (error: { message: string; reason_code: string }) => {
      console.log("error", error);
      if (error?.reason_code === "ERR00109") {
        setInvalidFund(error?.message);
      } else {
        if (openNotification) {
          openNotification({
            key: "error",
            message: error?.message || "Change status failed!",
            type: "error",
          });
        }
        resetEditingId();
        refetchExchange();
        close();
        queryResult?.remove();
      }
      setStatusChange(null);
    },
  });

  useEffect(() => {
    if (!data) return;
    formProps?.form?.setFieldsValue({
      dateOfExchange: data?.data?.data?.createdAt,
      paymentAmount: data?.data?.data?.paymentAmount,
      receiveAmount: data?.data?.data?.receiveAmount,
      currency: data?.data?.data?.paymentCurrency?.symbol,
      receiveCurrency: data?.data?.data?.receiveCurrency?.symbol,
    });
  }, [data, statusChange]);

  const onClose = useCallback(() => {
    setInvalidFund("");
    close();
  }, [close]);

  const afterClose = useCallback(() => {
    resetEditingId();
    queryResult?.remove();
  }, [queryResult, resetEditingId]);

  const handleChangeStatus = () => {
    mutate({ id: id as number, status: statusChange });
  };

  const handleCancel = () => {
    if (isLoading) return;
    setStatusChange(null);
  };

  const getTitle = () => {
    return id ? `#${id}` : '';
  }
  return (
    <>
      <Modal
        {...modalProps}
        className="smartModalTitle"
        title={`Exchange Money ${getTitle()}`}
        destroyOnClose
        maskClosable={false}
        footer={
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ color: "red" }}>{invalidFund}</div>
            <Row
              style={{
                justifyContent: "space-around",
                justifyItems: "center",
                width: "400px",
              }}
            >
              <Button
                key="reject"
                type={isAdminRole ? "primary" : undefined}
                onClick={() => setStatusChange("REJECTED")}
                loading={false}
                className="ant-btn-rejected"
                disabled={!(data?.data?.data?.status === PaymentStatus.PENDING)}
              >
                Reject
              </Button>
              <Button
                key="approve"
                type={isAdminRole ? "primary" : undefined}
                onClick={() => setStatusChange("APPROVED")}
                loading={false}
                disabled={!(data?.data?.data?.status === PaymentStatus.PENDING)}
              >
                Approve
              </Button>
            </Row>
          </Col>
        }
        onCancel={onClose}
        afterClose={afterClose}
      >
        <Form
          {...formProps}
          validateTrigger={false}
          className="detail-withdraw"
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography style={{ fontSize: "16px", fontWeight: 600 }}>
              Order {data?.data?.data?.walletOrder?.orderId ?? ''}
            </Typography>
            <Badge
              color={paymentStatusColors[data?.data?.data?.status]}
              text={paymentStatusNames[data?.data?.data?.status]}
            />
          </div>
          <hr />
          <TextContent
            label="Total to pay"
            value={`${data?.data?.data?.totalPaymentAmount
              ? Number(data?.data?.data?.totalPaymentAmount).toFixed(data?.data?.data?.paymentCurrency?.decimals)
              : 0
              } ${data?.data?.data?.paymentCurrency?.symbol}`}
            boldValue={true}
          />
          <TextContent
            label="Fees"
            value={`${data?.data?.data?.fee
              ? Number(data?.data?.data?.fee).toFixed(data?.data?.data?.paymentCurrency?.decimals)
              : 0
              } ${data?.data?.data?.paymentCurrency?.symbol}`}
            boldValue={true}
          />
          <TextContent
            label="Receive"
            value={`${data?.data?.data?.receiveAmount
              ? Number(data?.data?.data?.receiveAmount).toFixed(data?.data?.data?.receiveCurrency?.decimals)
              : 0
              } ${data?.data?.data?.receiveCurrency?.symbol}`}
            boldValue={true}
          />
          <hr />
          <TextContent
            label="Order Time"
            value={moment(data?.data?.data?.createdAt).format(
              "HH:mm:ss DD/MM/YYYY"
            )}
          />
        </Form>
      </Modal>
      <Modal
        key={"Confirm"}
        open={statusChange}
        className="smartModalTitle"
        title={`Confirm`}
        destroyOnClose
        maskClosable={false}
        footer={
          <Col>
            <Row
              style={{
                justifyContent: "space-around",
                justifyItems: "center",
                width: "400px",
              }}
            >
              <Button
                key="cancel"
                type={undefined}
                onClick={handleCancel}
                loading={isLoading}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                key="confirm"
                type={"primary"}
                onClick={handleChangeStatus}
                loading={isLoading}
                disabled={isLoading}
              >
                Confirm
              </Button>
            </Row>
          </Col>
        }
        onCancel={handleCancel}
      >
        <div>
          <Typography>
            Do you want to{" "}
            {statusChange === PaymentStatus.REJECTED ? "rejecte" : "complete"}{" "}
            this exchange?
          </Typography>
        </div>
      </Modal>
    </>
  );
};
